function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "par-path-1",
  points: "0 0 20.8448 0 20.8448 24.9999 0 24.9999"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.1299,11.4624 C11.9979,11.4624 12.4319,11.2544 12.7339,10.9344 C13.0169,10.6324 13.1669,10.2544 13.1669,9.8214 C13.1669,9.3874 13.0169,8.9914 12.7339,8.6894 C12.4319,8.3684 11.9979,8.1614 11.1299,8.1614 L8.8279,8.1614 L8.8279,11.4624 L11.1299,11.4624 Z M8.8279,13.7264 L8.8279,19.1034 L6.2809,19.1034 L6.2809,5.8974 L11.2429,5.8974 C12.9419,5.8974 13.9409,6.3124 14.6769,7.0854 C15.3369,7.7644 15.7139,8.7834 15.7139,9.8214 C15.7139,10.8584 15.3369,11.8774 14.6769,12.5564 C13.9599,13.3114 12.9419,13.7264 11.2429,13.7264 L8.8279,13.7264 Z",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "par-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#par-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.2158,2.2729 C2.6948,2.2729 2.2728,2.6949 2.2728,3.2149 L2.2728,21.7849 C2.2728,22.3049 2.6948,22.7269 3.2158,22.7269 L17.6298,22.7269 C18.1498,22.7269 18.5718,22.3049 18.5718,21.7849 L18.5718,3.2149 C18.5718,2.6949 18.1498,2.2729 17.6298,2.2729 L3.2158,2.2729 Z M17.6298,24.9999 L3.2158,24.9999 C1.4428,24.9999 -0.0002,23.5579 -0.0002,21.7849 L-0.0002,3.2149 C-0.0002,1.4419 1.4428,-0.0001 3.2158,-0.0001 L17.6298,-0.0001 C19.4028,-0.0001 20.8448,1.4419 20.8448,3.2149 L20.8448,21.7849 C20.8448,23.5579 19.4028,24.9999 17.6298,24.9999 L17.6298,24.9999 Z",
  fill: "#FEFEFE",
  mask: "url(#par-mask-2)"
}))));

var SvgParking = function SvgParking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parking.15596914.svg";
export { ForwardRef as ReactComponent };